export const nav = (isNavToggled,isPanelToggled)  => {
  
  const nav = document.querySelector(".js-nav");
  const header = document.querySelector(".js-header");
  const btnToggleNav = document.querySelector(".js-nav-toggle");

  const init = () => {
    updateNavState();
    bind();
  };

  const bind = () => {

    if (btnToggleNav) {
      btnToggleNav.onclick = function (e) {
        e.preventDefault();
        e.stopPropagation();
        isNavToggled = !isNavToggled;
        updateNavState();
      };

      //Add mouseover event that adds a class to the header, which is used to style the nav. Remove the class on mouseout.
      btnToggleNav.addEventListener("mouseover", function () {
        document.body.setAttribute("data-menu-hover", "true");
      }
      );

      btnToggleNav.addEventListener("mouseout", function () {
        document.body.setAttribute("data-menu-hover", "false");
      }
      );



    }

  };

  const updateNavState = () => {
    if (isNavToggled) {
      nav.setAttribute("aria-hidden", false);
      nav.setAttribute("data-state", "open");
      document.body.setAttribute("data-menu-open", "true");
    } else {
      nav.setAttribute("aria-hidden", true);
      nav.setAttribute("data-state", "closed");
      document.body.setAttribute("data-menu-open", "false");
    }
  };

  init();

};


